import { MdFileUpload } from "react-icons/md";
import Card from "components/card";
import React, { useState } from "react";
import axios from "axios";
import toast from "react-hot-toast";
import { API_BASE_URL } from "../../../../config";

const Upload = () => {
  const [selectedFile, setSelectedFile] = useState(null);
  const [preview, setPreview] = useState(null);
  const [loading, setLoading] = useState(false);
  const token = localStorage.getItem("token");

  // Handle file change
  const handleFileChange = (e) => {
    const file = e.target.files[0];
    setSelectedFile(file);

    if (file) {
      const reader = new FileReader();
      reader.onloadend = () => setPreview(reader.result);
      reader.readAsDataURL(file);
    }
  };

  // Handle upload
  const handleUpload = async () => {
    if (!selectedFile) {
      toast.error("Please select a file first.");
      return;
    }

    const formData = new FormData();
    formData.append("profilePhoto", selectedFile);

    const loadingToast = toast.loading("Uploading...");
    try {
      setLoading(true);

      const response = await axios.post(
        `${API_BASE_URL}/api/admin/admin-editProfile`,
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
            token,
          },
        }
      );

      if (response?.data?.statusCode === 200) {
        toast.success(response?.data?.message || "Profile photo updated successfully!");
        // console.log("Upload Success:", response.data);
        // Optionally reset
        setSelectedFile(null);
        setPreview(null);
      } else {
        toast.error(response?.data?.message || "Upload failed.");
      }

    } catch (err) {
      // console.error("Upload Error:", err);
      toast.error("Error uploading profile photo.");
    } finally {
      toast.dismiss(loadingToast);
      setLoading(false);
    }
  };

  return (
    <Card className="grid h-full w-full grid-cols-1 gap-3 rounded-[20px] bg-white bg-clip-border p-3 font-dm shadow-3xl shadow-shadow-500 dark:!bg-navy-800 dark:shadow-none 2xl:grid-cols-11">
      <div className="col-span-5 h-full w-full rounded-xl bg-lightPrimary dark:!bg-navy-700 2xl:col-span-6">
        <label htmlFor="file-upload">
          <div className="flex h-full w-full cursor-pointer flex-col items-center justify-center rounded-xl border-[2px] border-dashed border-gray-200 py-3 dark:!border-navy-700 lg:pb-0">
            {preview ? (
              <img
                src={preview}
                alt="Preview"
                className="h-[120px] w-[120px] rounded-full object-cover"
              />
            ) : (
              <>
                <MdFileUpload className="text-[80px] text-brand-500 dark:text-white" />
                <h4 className="text-xl font-bold text-brand-500 dark:text-white">
                  Upload Files
                </h4>
                <p className="mt-2 text-sm font-medium text-gray-600">
                  PNG, JPG and GIF files are allowed
                </p>
              </>
            )}
          </div>
        </label>
        <input
          id="file-upload"
          type="file"
          accept="image/png, image/jpeg, image/jpg, image/gif"
          onChange={handleFileChange}
          className="hidden"
        />
      </div>

      <div className="col-span-5 flex h-full w-full flex-col justify-center overflow-hidden rounded-xl bg-white pl-3 pb-4 dark:!bg-navy-800">
        <h5 className="text-left text-xl font-bold leading-9 text-navy-700 dark:text-white">
          Complete Your Profile
        </h5>
        <p className="leading-1 mt-2 text-base font-normal text-gray-600">
          Stay on the pulse of distributed projects with an online whiteboard to
          plan, coordinate and discuss
        </p>
        <button
          onClick={handleUpload}
          disabled={loading}
          className="linear mt-4 flex items-center justify-center rounded-xl bg-brand-500 px-2 py-2 text-base font-medium text-white transition duration-200 hover:bg-brand-600 active:bg-brand-700 dark:bg-brand-400 dark:text-white dark:hover:bg-brand-300 dark:active:bg-brand-200"
        >
          {loading ? "Uploading..." : "Publish now"}
        </button>
      </div>
    </Card>
  );
};

export default Upload;
